import script from "./FontFamilyActionMenuButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FontFamilyActionMenuButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__